// Copyright (c) 2019-24 Stax·ai, Inc.
// See LICENSE.md file in project root directory

import React from 'react';

export default class Checkbox extends React.Component {

    render = () => {        
        // return (<div
        //     className={"checkbox-container" + (this.props.className ? " " + this.props.className : "")}
        //     style={{
        //         ...(this.props.style ? this.props.style : {}),
        //         backgroundImage: "url('https://static.stax.ai/images/icons/" + (this.props.checked ? "reviewed" : "unchecked") + ".png')"
        //     }}
        //     onClick={this.props.onToggle}
        //     title={this.props.tooltip ? this.props.tooltip : "Click to toggle"}
        // >
        //     {this.props.label}                        
        // </div>);
        return (<>
            <label
                className={"checkbox" + (this.props.className ? " " + this.props.className : "") + (this.props.disabled ? " checkbox-disabled" : "")}
                title={this.props.tooltip ? this.props.tooltip : this.props.label}
                style={this.props.style ? this.props.style : {}}
                onContextMenu={this.props.onContextMenu ? this.props.onContextMenu : () => {}}
            >
                {this.props.label}
                <input
                    type="checkbox"
                    checked={this.props.checked}
                    onChange={this.props.onToggle}
                    disabled={this.props.disabled ? true : false}
                />
                <span className="checkmark" />
            </label>
            <div style={{ clear: 'both' }} />
        </>);
    }

};